/* =========================================================
   GLOBAL CLICK HANDLER
   - Product page quantity (local)
   - Cart page quantity + remove (Shopify sync)
========================================================= */
document.addEventListener("click", async (e) => {

  /* ===============================
     QUANTITY BUTTONS (+ / −)
  =============================== */
  const qtyBtn = e.target.closest(".hp-qty__btn");
  if (qtyBtn) {
    e.preventDefault(); // Stops accidental double-fires
    const change = Number(qtyBtn.dataset.change || 0);

    /* ===============================
       CART PAGE (has data-cart-line)
    =============================== */
    const cartLine = qtyBtn.closest("[data-cart-line]");
    if (cartLine) {
      if (cartLine.dataset.loading === "true") return;

      cartLine.dataset.loading = "true";
      cartLine.classList.add("opacity-50");

      const line = Number(cartLine.dataset.line);
      const input = cartLine.querySelector(".hp-qty__input");
      if (!input) return;

      const currentQty = Number(input.value);
      const newQty = Math.max(1, currentQty + change);

      /* UI first */
      input.value = newQty;

      await changeCart(line, newQty);
      
      // ✅ THE FIX: Tell the Drawer to update if it exists!
      if (window.DrawerControls) {
        window.DrawerControls.refresh();
      } else {
        await refreshCartSection();
      }
      return;
    }

    /* ===============================
       PRODUCT PAGE (NO cart sync)
    =============================== */
    const productQty = qtyBtn.closest(".hp-qty");
    if (productQty) {
      const input = productQty.querySelector(".hp-qty__input");
      if (!input) return;

      const min = Number(input.getAttribute("min")) || 1;
      const current = Number(input.value) || 1;

      input.value = Math.max(min, current + change);
    }
  }

  /* =========================================================
     REMOVE ITEM (CART PAGE)
  ========================================================= */
  const removeBtn = e.target.closest("[data-remove-line]");
  if (removeBtn) {
    e.preventDefault();
    const cartLine = removeBtn.closest("[data-cart-line]");
    if (!cartLine) return;

    if (cartLine.dataset.loading === "true") return;

    cartLine.dataset.loading = "true";
    cartLine.classList.add("opacity-50");

    const line = Number(removeBtn.dataset.removeLine);

    await changeCart(line, 0);
    
    // ✅ THE FIX: Tell the Drawer to update if it exists!
    if (window.DrawerControls) {
      window.DrawerControls.refresh();
    } else {
      await refreshCartSection();
    }
  }
});


/* =========================================================
   SHOPIFY CART CHANGE (API ONLY)
========================================================= */
async function changeCart(line, quantity) {
  try {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line, quantity })
    });

    if (!res.ok) throw new Error("Cart update failed");

  } catch (err) {
    console.error("Cart error:", err);
  }
}


/* =========================================================
   RELOAD CART HTML (LIQUID = SOURCE OF TRUTH)
========================================================= */
async function refreshCartSection() {
  const res = await fetch(window.location.pathname);
  const html = await res.text();

  const temp = document.createElement("div");
  temp.innerHTML = html;

  const newCart = temp.querySelector("[data-cart-main]");
  const currentCart = document.querySelector("[data-cart-main]");

  if (newCart && currentCart) {
    currentCart.innerHTML = newCart.innerHTML;
  }
}